"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4825],{

/***/ 24825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dj": function() { return /* binding */ adhesivesArr; },
/* harmony export */   "hW": function() { return /* binding */ countries; }
/* harmony export */ });
/* unused harmony export tile_size */
const tile_size = [
    {
        tileValue: 264,
        tileName: "600x600"
    },
    {
        tileValue: 262,
        tileName: "600x1200"
    },
    {
        tileValue: 266,
        tileName: "300x600"
    },
    {
        tileValue: 268,
        tileName: "300x300"
    },
    {
        tileValue: 267,
        tileName: "300x450"
    },
    {
        tileValue: 257,
        tileName: "1200x2400"
    },
    {
        tileValue: 455,
        tileName: "800x2400"
    },
    {
        tileValue: 263,
        tileName: "800x800"
    },
    {
        tileValue: 260,
        tileName: "800x1600"
    },
    {
        tileValue: 272,
        tileName: "195x1200"
    },
    {
        tileValue: 258,
        tileName: "1200x1200"
    },
    {
        tileValue: 259,
        tileName: "1000x1000"
    },
    {
        tileValue: 261,
        tileName: "800x1200"
    },
    {
        tileValue: 336,
        tileName: "400x400"
    },
    {
        tileValue: 265,
        tileName: "395x395"
    },
    {
        tileValue: 269,
        tileName: "295x295"
    },
    {
        tileValue: 270,
        tileName: "250x375"
    },
    {
        tileValue: 271,
        tileName: "200x300"
    },
    {
        tileValue: 273,
        tileName: "145x600"
    },
    {
        tileValue: 274,
        tileName: "200x1200"
    },
    {
        tileValue: 335,
        tileName: "148x600"
    },
    {
        tileValue: 480,
        tileName: "300x1200"
    },
    {
        tileValue: 497,
        tileName: "1200x1800"
    }
];
const adhesivesArr = [
    {
        title: "Type 1 MasterBond Adhesive",
        describtion: "Type 1 MasterBond Adhesive is ideal for ceramic tiles and small-format natural stone installed in dry interior settings. There are many types of applications that you can use this adhesive for, whether it's for tiling a kitchen backsplash, bathroom floor, or living room corner. This adhesive offers excellent grip, quick setting time, and a smooth application process. Spaces with vertical surfaces, which require precise tile alignment, can be secured with Type 1 Masterbond Adhesive without sagging. ",
        products: [
            {
                name: "OBL 305 StrongFix Grey",
                description: "OBL-305 StrongFix Grey is a polymer-based adhesive ideal for fixing ceramic and small-format natural stone tiles on dry interior walls and floors. It offers excellent workability, strong bonding to cementitious surfaces, and easy water-mix application. Designed for up to 12mm bed thickness, it complies with EN 12004 (C1T) and exceeds IS 15477:2019 standards. The adhesive is economical, single-component, and suitable for a variety of substrates like concrete, plaster, and masonry. Perfect for residential and commercial dry interior tile installations.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-305-StrongFix-Grey.jpg",
                weight: "20 kg",
                bullets: [
                    "For Ceramic Tiles & Small Natural Stones",
                    "Dry Interior Walls & Floors",
                    "Economical & Easy To Apply"
                ],
                color: "Grey"
            },
            {
                name: "OBL 307 StrongFix Plus Grey",
                description: "OBL-307 StrongFix Plus Grey is a polymer-based tile adhesive designed for fixing small to medium ceramic, semi-vitrified, and natural stone tiles on dry interior walls and floors. It ensures superior strength, better workability, and easy application by just adding water. Suitable for a wide range of cement-based substrates, it can be used up to 12mm bed thickness. The adhesive complies with EN 12004 (C1T) and exceeds IS 15477:2019 standards. Ideal for residential and commercial tiling with enhanced durability and bond strength.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-307-StrongFix-Plus-Grey.jpg",
                bullets: [
                    "Dry Interior Walls & Floors",
                    "Medium Size Tiles/Small Stones",
                    "Ceramic, Porcelain or Natural Stones"
                ],
                weight: "20 kg",
                color: "Grey"
            }
        ]
    },
    {
        title: "Type 2 MasterBond Adhesive",
        describtion: "Type 2 MasterBond Adhesive is a polymer-modified adhesive specifically designed to bond ceramic, vitrified, and natural stone tiles for interior and exterior applications. Its strong hold and extended open time make it ideal for tile-on-tile applications where precise positioning and permanent grip are required. This durable bond bridge has minor substrate imperfections and is crack-resistant, making it ideal for high-traffic areas such as living rooms, hallways, and expansive commercial interior spaces. Paired with the large-size tiles and Type 2 adhesive, the end result is a high-performance, stunning finish that will last for years to come.",
        products: [
            {
                name: "OBL 315 PowerFix Grey",
                description: "OBL-315 PowerFix Grey is a versatile, polymer-modified adhesive designed for ceramic, vitrified, and natural stone tiles on interior and exterior surfaces. With high bond strength, tile-on-tile compatibility, and smooth application, it ensures lasting results. Certified as C2T and compliant with IS 15477:2019 Type 2T, it delivers strength, precision, and durability for every project.",
                bullets: [
                    "For Ceramic, Vitrified Tiles & Natural Stones",
                    "For Interior Walls/Floors and Exterior Floor",
                    "Tile-on-Tile Application"
                ],
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-315-PowerFix-Grey.jpg",
                weight: "20 kg",
                color: "Grey"
            },
            {
                name: "OBL 315 PowerFix White",
                description: "OBL-315 PowerFix White is a high-bond, polymer-modified adhesive ideal for light-colored tiles, marbles, and glass mosaics. Its smooth white finish ensures clean aesthetics while supporting tile-on-tile applications on interior walls and exterior floors. Suitable for various cement-based substrates, it complies with C2T and IS 15477:2019 Type 2T standards, delivering strength and precision where it matters most.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-315-PowerFix-White.jpg",
                bullets: [
                    "For Ceramic, Vitrified Tiles & Natural Stones",
                    "For Interior Wall/Floor and Exterior Floors",
                    "Tile-on-Tile Application",
                    "For Light-Colored Tiles, Marbles & Glass Mosaics"
                ],
                weight: "20 kg",
                color: "White"
            }
        ]
    },
    {
        title: "Type 3 MasterBond Adhesive",
        describtion: "In wet and damp spaces, such as bathrooms, outdoor patios, or balconies where both tile size and setting are crucial, Type 3 adhesive is engineered to deliver exceptional bonding strength and moisture resistance. Perfect for large-format ceramic tiles, this adhesive forms a durable barrier against moisture seepage, ensuring long-lasting adhesion even in areas subject to temperature fluctuations and constant dampness. Its good underwater shear bond strength makes it suitable for critical wet areas like swimming pools, saunas, and water bodies, where conventional adhesives often fail.",
        products: [
            {
                name: "OBL 325 FlexHold Grey",
                description: "OBL-325 FlexHold Grey is a high-strength, polymer-modified adhesive specially formulated for wet and heavy-duty environments. Its excellent shock and water resistance makes it ideal for fixing large vitrified tiles, stones, and mosaics on interior and exterior surfaces. Suitable for bathrooms, pools, and high-traffic zones, it also supports tile-on-tile and wet-on-wet slurry applications. Backed by C2TE classification and IS 15477:2019 Type 3T compliance, it ensures superior bonding on a variety of substrates.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-325-FlexHold-Grey.jpg",
                weight: "20 kg",
                bullets: [
                    "Suitable for Wet Areas",
                    "Interior/Exterior Walls and Floors",
                    "For Large Vitrified Tiles & Natural Stones"
                ],
                color: "Grey"
            },
            {
                name: "OBL 325 FlexHold White",
                description: "OBL-325 FlexHold White is a polymer-modified adhesive for wet areas and heavy-duty applications. With its water-resistance and shock-absorption properties, it finds perfect use in the laying of light-colored vitrified tiles, marbles, and glass mosaics on both interior and exterior surfaces. With excellent underwater shear bond, it's well-suited for swimming pools, saunas, and water bodies. Certified as C2TE and compliant with IS 15477:2019 Type 3T, it ensures reliable performance on diverse substrates.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-325-FlexHold-White.jpg",
                bullets: [
                    "Suitable for Wet Areas",
                    "Interior/Exterior Walls and Floors",
                    "For Large Vitrified Tiles & Natural Stones",
                    "For Light-Colored Tiles, Marbles & Glass Mosaics"
                ],
                weight: "20 kg",
                color: "White"
            }
        ]
    },
    {
        title: "Type 3 S1 MasterBond Adhesive",
        describtion: "Type 3 S1 MasterBond Adhesive is a high-performance adhesive specially formulated for large tiles and natural stone installations in wet and submerged areas. It delivers strong, shock-resistant bonding for large vitrified tiles, natural stones, and mosaics on interior or exterior walls and floors. Certified C2TES1 / IS 15477:2019 Type 3TS1, it ensures durable performance where moisture and movement are constant.",
        products: [
            {
                name: "OBL 335 AquaFlex Grey",
                description: "OBL-335 AquaFlex Grey is a high-flex, polymer-modified adhesive designed for large-format tiles and natural stones in wet and submerged environments. With excellent shock absorption and water resistance, it ensures secure bonding on both interior and exterior walls and floors. Ideal for pools, patios, and washrooms, it meets C2TES1 and IS 15477:2019 Type 3TS1 standards, delivering strength and long-lasting durability in the toughest conditions.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-335-AquaFlex-Grey.jpg",
                weight: "20 kg",
                bullets: [
                    "For Large Vitrified Tiles & Natural Stones",
                    "For Submerged Areas",
                    "Interior/Exterior Walls & Floors"
                ],
                color: "Grey"
            },
            {
                name: "OBL 335 AquaFlex White",
                description: "OBL-335 AquaFlex White features the same high-performance adhesive technology with a white finish, making it ideal for light-coloured tiles, marbles, and glass mosaics. Its non-staining formula preserves the visual integrity of delicate surfaces while providing strong adhesion in wet, submerged, and external areas. Certified as C2TES1 and compliant with IS 15477:2019 Type 3TS1, it's ideal for premium installations where aesthetics and performance go hand in hand.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-335-AquaFlex-White.jpg",
                weight: "20 kg",
                color: "White",
                bullets: [
                    "For Large Vitrified Tiles & Natural Stones",
                    "For Submerged Areas",
                    "Interior/Exterior Walls & Floors",
                    "For Light-Coloured Tiles, Marbles & Glass Mosaics"
                ]
            }
        ]
    },
    {
        title: "Type 4 S2 MasterBond Adhesive",
        describtion: "Type 4 S2 MasterBond Adhesive is a high-performance, extremely flexible adhesive for extreme installations of large-sized stone and tile slabs. Engineered for extreme conditions and structural movement, it provides superior flexibility, sag resistance, and longer open time. Ideal for exterior cladding, facades, and weather-exposed installation, it supports up to 18 mm bed thickness without compromising bond strength. Approved C2TES2 and as per IS 15477:2019 Type 4TS2, it has unmatched toughness and resistance to deformation for the most demanding tiling conditions.",
        products: [
            {
                name: "OBL 345 UltraFlex Grey",
                description: "Built to perform in the toughest conditions, OBL 345 UltraFlex Grey is a high-performance tile adhesive engineered for exterior cladding and large-format stone installations. Its high-polymer modification ensures superior deformability, strength, and flexibility — even in extreme weather conditions. Ideal for vertical and horizontal surfaces, it resists sagging and supports bed thickness up to 18 mm. With a strong water shear bond, it's a reliable solution for facades, wet areas, and structural tiling where durability can't be compromised.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-345-UltraFlex-Grey.jpg",
                weight: "20 kg",
                bullets: [
                    "For extra-large stones & Tiles slabs",
                    "Good for External cladding",
                    "Suitable for all weather."
                ],
                color: "Grey"
            },
            {
                name: "OBL 345 UltraFlex White",
                description: "A perfect blend of aesthetics and performance, OBL 345 UltraFlex White is a deformable adhesive ideal for light-colored marbles, glass mosaics, and premium tiles. Designed for exterior and interior cladding, it offers exceptional handling with excellent sag resistance and extended open time. Suitable for demanding environments like swimming pools or facades, this high polymer formulation ensures flawless finishes and long-lasting bonds, with up to 18 mm bed thickness and adherence to global Type 4TS2 standards.",
                image: "https://images.orientbell.com/media/Adhesive-Images/OBL-345-UltraFlex-White.jpg",
                weight: "20 kg",
                color: "White",
                bullets: [
                    "For extra-large stones & Tiles slabs",
                    "Good for External cladding",
                    "Suitable for all weather.",
                    "For Light-Coloured Tiles, Marbles & Glass Mosaics"
                ]
            }
        ]
    }
];
const countries = [
    {
        name: "Afghanistan",
        code: "93",
        cc: "AF"
    },
    {
        name: "Albania",
        code: "355",
        cc: "AL"
    },
    {
        name: "Algeria",
        code: "213",
        cc: "DZ"
    },
    {
        name: "American Samoa",
        code: "1-684",
        cc: "AS"
    },
    {
        name: "Andorra",
        code: "376",
        cc: "AD"
    },
    {
        name: "Angola",
        code: "244",
        cc: "AO"
    },
    {
        name: "Anguilla",
        code: "1-264",
        cc: "AI"
    },
    {
        name: "Antarctica",
        code: "672",
        cc: "AQ"
    },
    {
        name: "Antigua and Barbuda",
        code: "1-268",
        cc: "AG"
    },
    {
        name: "Argentina",
        code: "54",
        cc: "AR"
    },
    {
        name: "Armenia",
        code: "374",
        cc: "AM"
    },
    {
        name: "Aruba",
        code: "297",
        cc: "AW"
    },
    {
        name: "Australia",
        code: "61",
        cc: "AU"
    },
    {
        name: "Austria",
        code: "43",
        cc: "AT"
    },
    {
        name: "Azerbaijan",
        code: "994",
        cc: "AZ"
    },
    {
        name: "Bahamas",
        code: "1-242",
        cc: "BS"
    },
    {
        name: "Bahrain",
        code: "973",
        cc: "BH"
    },
    {
        name: "Bangladesh",
        code: "880",
        cc: "BD"
    },
    {
        name: "Barbados",
        code: "1-246",
        cc: "BB"
    },
    {
        name: "Belarus",
        code: "375",
        cc: "BY"
    },
    {
        name: "Belgium",
        code: "32",
        cc: "BE"
    },
    {
        name: "Belize",
        code: "501",
        cc: "BZ"
    },
    {
        name: "Benin",
        code: "229",
        cc: "BJ"
    },
    {
        name: "Bermuda",
        code: "1-441",
        cc: "BM"
    },
    {
        name: "Bhutan",
        code: "975",
        cc: "BT"
    },
    {
        name: "Bolivia",
        code: "591",
        cc: "BO"
    },
    {
        name: "Bosnia and Herzegovina",
        code: "387",
        cc: "BA"
    },
    {
        name: "Botswana",
        code: "267",
        cc: "BW"
    },
    {
        name: "Brazil",
        code: "55",
        cc: "BR"
    },
    {
        name: "British Indian Ocean Territory",
        code: "246",
        cc: "IO"
    },
    {
        name: "British Virgin Islands",
        code: "1-284",
        cc: "VG"
    },
    {
        name: "Brunei",
        code: "673",
        cc: "BN"
    },
    {
        name: "Bulgaria",
        code: "359",
        cc: "BG"
    },
    {
        name: "Burkina Faso",
        code: "226",
        cc: "BF"
    },
    {
        name: "Burundi",
        code: "257",
        cc: "BI"
    },
    {
        name: "Cambodia",
        code: "855",
        cc: "KH"
    },
    {
        name: "Cameroon",
        code: "237",
        cc: "CM"
    },
    {
        name: "Canada",
        code: "1",
        cc: "CA"
    },
    {
        name: "Cape Verde",
        code: "238",
        cc: "CV"
    },
    {
        name: "Cayman Islands",
        code: "1-345",
        cc: "KY"
    },
    {
        name: "Central African Republic",
        code: "236",
        cc: "CF"
    },
    {
        name: "Chad",
        code: "235",
        cc: "TD"
    },
    {
        name: "Chile",
        code: "56",
        cc: "CL"
    },
    {
        name: "China",
        code: "86",
        cc: "CN"
    },
    {
        name: "Christmas Island",
        code: "61",
        cc: "CX"
    },
    {
        name: "Cocos Islands",
        code: "61",
        cc: "CC"
    },
    {
        name: "Colombia",
        code: "57",
        cc: "CO"
    },
    {
        name: "Comoros",
        code: "269",
        cc: "KM"
    },
    {
        name: "Cook Islands",
        code: "682",
        cc: "CK"
    },
    {
        name: "Costa Rica",
        code: "506",
        cc: "CR"
    },
    {
        name: "Croatia",
        code: "385",
        cc: "HR"
    },
    {
        name: "Cuba",
        code: "53",
        cc: "CU"
    },
    {
        name: "Curacao",
        code: "599",
        cc: "CW"
    },
    {
        name: "Cyprus",
        code: "357",
        cc: "CY"
    },
    {
        name: "Czech Republic",
        code: "420",
        cc: "CZ"
    },
    {
        name: "Democratic Republic of the Congo",
        code: "243",
        cc: "CD"
    },
    {
        name: "Denmark",
        code: "45",
        cc: "DK"
    },
    {
        name: "Djibouti",
        code: "253",
        cc: "DJ"
    },
    {
        name: "Dominica",
        code: "1-767",
        cc: "DM"
    },
    {
        name: "Dominican Republic",
        code: "1-809, 1-829, 1-849",
        cc: "DO"
    },
    {
        name: "East Timor",
        code: "670",
        cc: "TL"
    },
    {
        name: "Ecuador",
        code: "593",
        cc: "EC"
    },
    {
        name: "Egypt",
        code: "20",
        cc: "EG"
    },
    {
        name: "El Salvador",
        code: "503",
        cc: "SV"
    },
    {
        name: "Equatorial Guinea",
        code: "240",
        cc: "GQ"
    },
    {
        name: "Eritrea",
        code: "291",
        cc: "ER"
    },
    {
        name: "Estonia",
        code: "372",
        cc: "EE"
    },
    {
        name: "Ethiopia",
        code: "251",
        cc: "ET"
    },
    {
        name: "Falkland Islands",
        code: "500",
        cc: "FK"
    },
    {
        name: "Faroe Islands",
        code: "298",
        cc: "FO"
    },
    {
        name: "Fiji",
        code: "679",
        cc: "FJ"
    },
    {
        name: "Finland",
        code: "358",
        cc: "FI"
    },
    {
        name: "France",
        code: "33",
        cc: "FR"
    },
    {
        name: "French Polynesia",
        code: "689",
        cc: "PF"
    },
    {
        name: "Gabon",
        code: "241",
        cc: "GA"
    },
    {
        name: "Gambia",
        code: "220",
        cc: "GM"
    },
    {
        name: "Georgia",
        code: "995",
        cc: "GE"
    },
    {
        name: "Germany",
        code: "49",
        cc: "DE"
    },
    {
        name: "Ghana",
        code: "233",
        cc: "GH"
    },
    {
        name: "Gibraltar",
        code: "350",
        cc: "GI"
    },
    {
        name: "Greece",
        code: "30",
        cc: "GR"
    },
    {
        name: "Greenland",
        code: "299",
        cc: "GL"
    },
    {
        name: "Grenada",
        code: "1-473",
        cc: "GD"
    },
    {
        name: "Guam",
        code: "1-671",
        cc: "GU"
    },
    {
        name: "Guatemala",
        code: "502",
        cc: "GT"
    },
    {
        name: "Guernsey",
        code: "44-1481",
        cc: "GG"
    },
    {
        name: "Guinea",
        code: "224",
        cc: "GN"
    },
    {
        name: "Guinea-Bissau",
        code: "245",
        cc: "GW"
    },
    {
        name: "Guyana",
        code: "592",
        cc: "GY"
    },
    {
        name: "Haiti",
        code: "509",
        cc: "HT"
    },
    {
        name: "Honduras",
        code: "504",
        cc: "HN"
    },
    {
        name: "Hong Kong",
        code: "852",
        cc: "HK"
    },
    {
        name: "Hungary",
        code: "36",
        cc: "HU"
    },
    {
        name: "Iceland",
        code: "354",
        cc: "IS"
    },
    {
        name: "India",
        code: "91",
        cc: "IN"
    },
    {
        name: "Indonesia",
        code: "62",
        cc: "ID"
    },
    {
        name: "Iran",
        code: "98",
        cc: "IR"
    },
    {
        name: "Iraq",
        code: "964",
        cc: "IQ"
    },
    {
        name: "Ireland",
        code: "353",
        cc: "IE"
    },
    {
        name: "Isle of Man",
        code: "44-1624",
        cc: "IM"
    },
    {
        name: "Israel",
        code: "972",
        cc: "IL"
    },
    {
        name: "Italy",
        code: "39",
        cc: "IT"
    },
    {
        name: "Ivory Coast",
        code: "225",
        cc: "CI"
    },
    {
        name: "Jamaica",
        code: "1-876",
        cc: "JM"
    },
    {
        name: "Japan",
        code: "81",
        cc: "JP"
    },
    {
        name: "Jersey",
        code: "44-1534",
        cc: "JE"
    },
    {
        name: "Jordan",
        code: "962",
        cc: "JO"
    },
    {
        name: "Kazakhstan",
        code: "7",
        cc: "KZ"
    },
    {
        name: "Kenya",
        code: "254",
        cc: "KE"
    },
    {
        name: "Kiribati",
        code: "686",
        cc: "KI"
    },
    {
        name: "Kosovo",
        code: "383",
        cc: "XK"
    },
    {
        name: "Kuwait",
        code: "965",
        cc: "KW"
    },
    {
        name: "Kyrgyzstan",
        code: "996",
        cc: "KG"
    },
    {
        name: "Laos",
        code: "856",
        cc: "LA"
    },
    {
        name: "Latvia",
        code: "371",
        cc: "LV"
    },
    {
        name: "Lebanon",
        code: "961",
        cc: "LB"
    },
    {
        name: "Lesotho",
        code: "266",
        cc: "LS"
    },
    {
        name: "Liberia",
        code: "231",
        cc: "LR"
    },
    {
        name: "Libya",
        code: "218",
        cc: "LY"
    },
    {
        name: "Liechtenstein",
        code: "423",
        cc: "LI"
    },
    {
        name: "Lithuania",
        code: "370",
        cc: "LT"
    },
    {
        name: "Luxembourg",
        code: "352",
        cc: "LU"
    },
    {
        name: "Macau",
        code: "853",
        cc: "MO"
    },
    {
        name: "Macedonia",
        code: "389",
        cc: "MK"
    },
    {
        name: "Madagascar",
        code: "261",
        cc: "MG"
    },
    {
        name: "Malawi",
        code: "265",
        cc: "MW"
    },
    {
        name: "Malaysia",
        code: "60",
        cc: "MY"
    },
    {
        name: "Maldives",
        code: "960",
        cc: "MV"
    },
    {
        name: "Mali",
        code: "223",
        cc: "ML"
    },
    {
        name: "Malta",
        code: "356",
        cc: "MT"
    },
    {
        name: "Marshall Islands",
        code: "692",
        cc: "MH"
    },
    {
        name: "Mauritania",
        code: "222",
        cc: "MR"
    },
    {
        name: "Mauritius",
        code: "230",
        cc: "MU"
    },
    {
        name: "Mayotte",
        code: "262",
        cc: "YT"
    },
    {
        name: "Mexico",
        code: "52",
        cc: "MX"
    },
    {
        name: "Micronesia",
        code: "691",
        cc: "FM"
    },
    {
        name: "Moldova",
        code: "373",
        cc: "MD"
    },
    {
        name: "Monaco",
        code: "377",
        cc: "MC"
    },
    {
        name: "Mongolia",
        code: "976",
        cc: "MN"
    },
    {
        name: "Montenegro",
        code: "382",
        cc: "ME"
    },
    {
        name: "Montserrat",
        code: "1-664",
        cc: "MS"
    },
    {
        name: "Morocco",
        code: "212",
        cc: "MA"
    },
    {
        name: "Mozambique",
        code: "258",
        cc: "MZ"
    },
    {
        name: "Myanmar",
        code: "95",
        cc: "MM"
    },
    {
        name: "Namibia",
        code: "264",
        cc: "NA"
    },
    {
        name: "Nauru",
        code: "674",
        cc: "NR"
    },
    {
        name: "Nepal",
        code: "977",
        cc: "NP"
    },
    {
        name: "Netherlands",
        code: "31",
        cc: "NL"
    },
    {
        name: "Netherlands Antilles",
        code: "599",
        cc: "AN"
    },
    {
        name: "New Caledonia",
        code: "687",
        cc: "NC"
    },
    {
        name: "New Zealand",
        code: "64",
        cc: "NZ"
    },
    {
        name: "Nicaragua",
        code: "505",
        cc: "NI"
    },
    {
        name: "Niger",
        code: "227",
        cc: "NE"
    },
    {
        name: "Nigeria",
        code: "234",
        cc: "NG"
    },
    {
        name: "Niue",
        code: "683",
        cc: "NU"
    },
    {
        name: "North Korea",
        code: "850",
        cc: "KP"
    },
    {
        name: "Northern Mariana Islands",
        code: "1-670",
        cc: "MP"
    },
    {
        name: "Norway",
        code: "47",
        cc: "NO"
    },
    {
        name: "Oman",
        code: "968",
        cc: "OM"
    },
    {
        name: "Pakistan",
        code: "92",
        cc: "PK"
    },
    {
        name: "Palau",
        code: "680",
        cc: "PW"
    },
    {
        name: "Palestine",
        code: "970",
        cc: "PS"
    },
    {
        name: "Panama",
        code: "507",
        cc: "PA"
    },
    {
        name: "Papua New Guinea",
        code: "675",
        cc: "PG"
    },
    {
        name: "Paraguay",
        code: "595",
        cc: "PY"
    },
    {
        name: "Peru",
        code: "51",
        cc: "PE"
    },
    {
        name: "Philippines",
        code: "63",
        cc: "PH"
    },
    {
        name: "Pitcairn",
        code: "64",
        cc: "PN"
    },
    {
        name: "Poland",
        code: "48",
        cc: "PL"
    },
    {
        name: "Portugal",
        code: "351",
        cc: "PT"
    },
    {
        name: "Puerto Rico",
        code: "1-787, 1-939",
        cc: "PR"
    },
    {
        name: "Qatar",
        code: "974",
        cc: "QA"
    },
    {
        name: "Republic of the Congo",
        code: "242",
        cc: "CG"
    },
    {
        name: "Reunion",
        code: "262",
        cc: "RE"
    },
    {
        name: "Romania",
        code: "40",
        cc: "RO"
    },
    {
        name: "Russia",
        code: "7",
        cc: "RU"
    },
    {
        name: "Rwanda",
        code: "250",
        cc: "RW"
    },
    {
        name: "Saint Barthelemy",
        code: "590",
        cc: "BL"
    },
    {
        name: "Saint Helena",
        code: "290",
        cc: "SH"
    },
    {
        name: "Saint Kitts and Nevis",
        code: "1-869",
        cc: "KN"
    },
    {
        name: "Saint Lucia",
        code: "1-758",
        cc: "LC"
    },
    {
        name: "Saint Martin",
        code: "590",
        cc: "MF"
    },
    {
        name: "Saint Pierre and Miquelon",
        code: "508",
        cc: "PM"
    },
    {
        name: "Saint Vincent and the Grenadines",
        code: "1-784",
        cc: "VC"
    },
    {
        name: "Samoa",
        code: "685",
        cc: "WS"
    },
    {
        name: "San Marino",
        code: "378",
        cc: "SM"
    },
    {
        name: "Sao Tome and Principe",
        code: "239",
        cc: "ST"
    },
    {
        name: "Saudi Arabia",
        code: "966",
        cc: "SA"
    },
    {
        name: "Senegal",
        code: "221",
        cc: "SN"
    },
    {
        name: "Serbia",
        code: "381",
        cc: "RS"
    },
    {
        name: "Seychelles",
        code: "248",
        cc: "SC"
    },
    {
        name: "Sierra Leone",
        code: "232",
        cc: "SL"
    },
    {
        name: "Singapore",
        code: "65",
        cc: "SG"
    },
    {
        name: "Sint Maarten",
        code: "1-721",
        cc: "SX"
    },
    {
        name: "Slovakia",
        code: "421",
        cc: "SK"
    },
    {
        name: "Slovenia",
        code: "386",
        cc: "SI"
    },
    {
        name: "Solomon Islands",
        code: "677",
        cc: "SB"
    },
    {
        name: "Somalia",
        code: "252",
        cc: "SO"
    },
    {
        name: "South Africa",
        code: "27",
        cc: "ZA"
    },
    {
        name: "South Korea",
        code: "82",
        cc: "KR"
    },
    {
        name: "South Sudan",
        code: "211",
        cc: "SS"
    },
    {
        name: "Spain",
        code: "34",
        cc: "ES"
    },
    {
        name: "Sri Lanka",
        code: "94",
        cc: "LK"
    },
    {
        name: "Sudan",
        code: "249",
        cc: "SD"
    },
    {
        name: "Suriname",
        code: "597",
        cc: "SR"
    },
    {
        name: "Svalbard and Jan Mayen",
        code: "47",
        cc: "SJ"
    },
    {
        name: "Swaziland",
        code: "268",
        cc: "SZ"
    },
    {
        name: "Sweden",
        code: "46",
        cc: "SE"
    },
    {
        name: "Switzerland",
        code: "41",
        cc: "CH"
    },
    {
        name: "Syria",
        code: "963",
        cc: "SY"
    },
    {
        name: "Taiwan",
        code: "886",
        cc: "TW"
    },
    {
        name: "Tajikistan",
        code: "992",
        cc: "TJ"
    },
    {
        name: "Tanzania",
        code: "255",
        cc: "TZ"
    },
    {
        name: "Thailand",
        code: "66",
        cc: "TH"
    },
    {
        name: "Togo",
        code: "228",
        cc: "TG"
    },
    {
        name: "Tokelau",
        code: "690",
        cc: "TK"
    },
    {
        name: "Tonga",
        code: "676",
        cc: "TO"
    },
    {
        name: "Trinidad and Tobago",
        code: "1-868",
        cc: "TT"
    },
    {
        name: "Tunisia",
        code: "216",
        cc: "TN"
    },
    {
        name: "Turkey",
        code: "90",
        cc: "TR"
    },
    {
        name: "Turkmenistan",
        code: "993",
        cc: "TM"
    },
    {
        name: "Turks and Caicos Islands",
        code: "1-649",
        cc: "TC"
    },
    {
        name: "Tuvalu",
        code: "688",
        cc: "TV"
    },
    {
        name: "U.S. Virgin Islands",
        code: "1-340",
        cc: "VI"
    },
    {
        name: "Uganda",
        code: "256",
        cc: "UG"
    },
    {
        name: "Ukraine",
        code: "380",
        cc: "UA"
    },
    {
        name: "United Arab Emirates",
        code: "971",
        cc: "AE"
    },
    {
        name: "United Kingdom",
        code: "44",
        cc: "GB"
    },
    {
        name: "United States",
        code: "1",
        cc: "US"
    },
    {
        name: "Uruguay",
        code: "598",
        cc: "UY"
    },
    {
        name: "Uzbekistan",
        code: "998",
        cc: "UZ"
    },
    {
        name: "Vanuatu",
        code: "678",
        cc: "VU"
    },
    {
        name: "Vatican",
        code: "379",
        cc: "VA"
    },
    {
        name: "Venezuela",
        code: "58",
        cc: "VE"
    },
    {
        name: "Vietnam",
        code: "84",
        cc: "VN"
    },
    {
        name: "Wallis and Futuna",
        code: "681",
        cc: "WF"
    },
    {
        name: "Western Sahara",
        code: "212",
        cc: "EH"
    },
    {
        name: "Yemen",
        code: "967",
        cc: "YE"
    },
    {
        name: "Zambia",
        code: "260",
        cc: "ZM"
    },
    {
        name: "Zimbabwe",
        code: "263",
        cc: "ZW"
    }
];


/***/ })

}]);